import { ofType } from 'redux-observable';
import { tap, ignoreElements } from 'rxjs/operators';

import { actions } from '@ezugi/bootstrap';

import { gameVideoHandler } from '../../../utils';

const {
  videoActions,
} = actions;

function videoEpic(action$) {
  return action$.pipe(
    ofType(videoActions.video.play),
    tap(gameVideoHandler),
    ignoreElements()
  );
}

export default videoEpic;
